import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

import { colors } from '@/lib/analytics/colors';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_FULL } from '@/lib/gridElements/size';
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';

import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';
import { LineChart } from '@/components/composite/Charts/LineChart';

export const favoritesHistoryConfig = {
    title: 'chart.tiktok.favorites_history',
    id: 'favorites_history',
    tooltip: 'chart.tiktok.tooltip_favorites_history',
    icon: {
        name: 'favorites',
        style: colors.blue
    },
    name: {
        date: 'date',
        value: 'chart.tiktok.favorites_history_name',
        avg: 'chart.tiktok.favorites_history_avg'
    },
    color: {
        value: 'blue',
        avg: 'gray'
    },
    orientation: ORIENTATION_VERTICAL,
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_FULL,
    type: 'chart',
    mergedData: true,
    element: LineChart,
    loader: DefaultLoader,
    dashboardEligibleNetworks: [TIKTOK_BUSINESS],
    new: {
        dateAdded: '2025-08-06'
    }
};
